import { makeValidatedRequest } from './requestExecutor/make-validated-request';
import type { IHttpRequestWithBodyParams, IValidatedResponse } from './types';

export async function putRequest<T>({
  path,
  body,
  schema,
  options,
}: IHttpRequestWithBodyParams<T>): Promise<IValidatedResponse<T>> {
  return makeValidatedRequest({
    method: 'PUT',
    path,
    body,
    schema,
    options,
  });
}
